/**
 * The Wild Turtle — product-form.js
 * Product page: variant selection, ATC, price updates
 */

(() => {
  'use strict';

  const productEl = document.getElementById('product-page');
  if (!productEl) return;

  const productData = JSON.parse(productEl.dataset.product || '{}');
  const variants    = productData.variants || [];

  const form       = document.getElementById('product-form');
  const variantInput = document.getElementById('product-variant-id');
  const atcBtn     = document.getElementById('product-atc-btn');
  const priceEl    = document.getElementById('product-price');
  const errorEl    = document.getElementById('atc-error');

  /* =========================================================
     Variant matching
  ========================================================= */
  function getSelectedOptions() {
    const options = {};
    document.querySelectorAll('[data-option-position]').forEach(input => {
      if (input.checked || input.tagName === 'SELECT') {
        options[input.dataset.optionPosition] = input.value;
      }
    });
    return options;
  }

  function findVariant(options) {
    return variants.find(v =>
      v.options.every((opt, i) => opt === options[i + 1])
    );
  }

  function formatMoney(cents) {
    const fmt = window.themeData?.money_format || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
  }

  function updatePrice(variant) {
    if (!priceEl || !variant) return;
    const onSale = variant.compare_at_price > variant.price;
    let html = '';
    if (onSale) {
      const savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
      html = `
        <div class="price-wrap price-wrap--sale">
          <span class="price price--sale">${formatMoney(variant.price)}</span>
          <span class="price price--compare"><s>${formatMoney(variant.compare_at_price)}</s></span>
          <span class="badge badge--sale">${savings}% off</span>
        </div>`;
    } else {
      html = `<div class="price-wrap"><span class="price">${formatMoney(variant.price)}</span></div>`;
    }
    priceEl.innerHTML = html;
  }

  function updateButton(variant) {
    if (!atcBtn) return;
    if (!variant || !variant.available) {
      atcBtn.disabled = true;
      atcBtn.textContent = variant ? 'Sold Out' : 'Unavailable';
    } else {
      atcBtn.disabled = false;
      atcBtn.innerHTML = `Add to Cart <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:20px;height:20px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>`;
    }
  }

  function updateVariantId(variant) {
    if (variantInput && variant) variantInput.value = variant.id;
  }

  function updateURL(variant) {
    if (!variant) return;
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function updateOptionSelected(position, value) {
    const el = document.getElementById(`option-selected-${position}`);
    if (el) el.textContent = value;
  }

  function onVariantChange() {
    const selectedOptions = {};
    document.querySelectorAll('[data-option-position]').forEach(input => {
      if ((input.type === 'radio' && input.checked) || input.type !== 'radio') {
        selectedOptions[parseInt(input.dataset.optionPosition, 10)] = input.value;
        updateOptionSelected(parseInt(input.dataset.optionPosition, 10) - 1, input.value);
      }
    });

    const variant = findVariant(selectedOptions);
    updatePrice(variant);
    updateButton(variant);
    updateVariantId(variant);
    updateURL(variant);

    // Update gallery if variant has a featured image
    if (variant?.featured_media) {
      const slide = document.querySelector(`[data-media-id="${variant.featured_media.id}"]`);
      if (slide) {
        const mediaId = variant.featured_media.id;
        document.querySelectorAll('.product-gallery__slide').forEach(s => {
          const isTarget = s.dataset.mediaId == mediaId;
          s.classList.toggle('is-active', isTarget);
          isTarget ? s.removeAttribute('hidden') : s.setAttribute('hidden', '');
        });
        document.querySelectorAll('.product-gallery__thumb').forEach(t => {
          t.classList.toggle('is-active', t.dataset.mediaId == mediaId);
        });
      }
    }
  }

  // Listen for radio changes
  document.querySelectorAll('[data-option-position]').forEach(input => {
    input.addEventListener('change', onVariantChange);
  });

  /* =========================================================
     Add to Cart Form Submit
  ========================================================= */
  if (form) {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (atcBtn.disabled) return;

      const variantId = parseInt(variantInput.value, 10);
      const quantity  = parseInt(document.getElementById('product-quantity')?.value || 1, 10);

      atcBtn.classList.add('btn--loading');
      atcBtn.disabled = true;
      if (errorEl) errorEl.setAttribute('hidden', '');

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity }),
        }).then(r => { if (!r.ok) throw new Error('Add to cart failed'); return r.json(); });

        await window.CartDrawer?.refresh();
        window.CartDrawer?.open();
        window.showCartNotification?.('Added to cart');
      } catch (err) {
        if (errorEl) {
          errorEl.textContent = 'Sorry, this item could not be added to cart. Please try again.';
          errorEl.removeAttribute('hidden');
        }
        console.error('ATC error:', err);
      } finally {
        atcBtn.classList.remove('btn--loading');
        atcBtn.disabled = false;
      }
    });
  }

  // Init on load
  onVariantChange();

})();
